module.exports = __webpack_public_path__ + "img/bone-health-logo-dark.e4eb2671.svg";